
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild,ChangeDetectorRef, TemplateRef, ViewContainerRef, ChangeDetectionStrategy, AfterViewInit, AfterViewChecked, NgZone  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT, NgFor, NgForOf, NgTemplateOutlet } from '@angular/common';

import { Observable } from 'rxjs/internal/Observable';

// models ==========================================================================


// prime ng components ---------------------------------------------------------------
import { Table, TableModule, TablePageEvent, TableService } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmationService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { InputGroupModule } from 'primeng/inputgroup';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { IconFieldModule } from 'primeng/iconfield';
import { DropdownModule } from 'primeng/dropdown';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


// Random -----------------------------------------------------------------------------
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

// OUR COMPONENTS -------------------------------
import { filter } from 'lodash';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxClickEvent, ListboxModule } from 'primeng/listbox';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { GenericButtonComponent } from '../../../../../global/component/generic/generic-button/generic-button.component';
import { EventModalComponent } from '../../../../shared-components/event-modal/event-modal.component';
import { TableFilterComponent } from '../../../../../global/component/generic/table-filter/table-filter.component';
import { LoadingSpinnerComponent } from '../../../../../global/component/loading-spinner/loading-spinner.component';
import { GenericTextInputComponent } from '../../../../../global/component/generic/generic-text-input/generic-text-input.component';
import PagingModel from '../../../../../global/model/PagingMoel';
import { DisplayColumn, FilterModel, FilterOperators, LookupFilter, SearchModel } from '../../../../../global/model/SearchModel';
import { EventModel } from '../../../../models/EventModel';
import { SearchService } from '../../../../../global/services/data/search-service/searchservice';
import { EventService } from '../../../../services/event.service';
import { ServerClientService } from '../../../../../global/services/data/campaign-service/server-client.service';
import { MainModel } from '../../../../../global/model/MainModel';
import { UserPermissionsService } from '../../../../../global/services/permissions/UserPermissionsService';
import { TableDataType } from '../../../../../global/model/ExportColumn';
import { MatchType } from '../../../../../global/model/search/MatchType';
import { exportToExcel } from '../../../../../global/util/util';
import { catchError, EMPTY, race, shareReplay, switchMap, timer } from 'rxjs';

@Component({
  selector: 'app-expense-transactions-report',
  standalone: true,
  imports: [TableModule, SplitButtonModule, InputTextModule, CheckboxModule, CalendarModule,
    DropdownModule, CommonModule, NgFor, NgForOf, DialogModule,
    ButtonModule, FormsModule, MultiSelectModule, ToggleButtonModule, MenuModule, GenericButtonComponent,
    ToastModule, TagModule, InputGroupModule, InputIconModule, IconFieldModule, CardModule, ListboxModule,ConfirmDialogModule,
    DialogModule, GenericTextInputComponent, LoadingSpinnerComponent, EventModalComponent, TableFilterComponent],
  providers: [MessageService, ConfirmationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './expense-transactions-report.component.html',
  styleUrl: './expense-transactions-report.component.scss'
})
export class ExpenseTransactionsReportComponent implements OnInit {

  @Input({ required: !true }) dataType: TableDataType = TableDataType.Report_Expenses;
  pagingModel: PagingModel = new PagingModel();
  @Output() dataViewUpdate = new EventEmitter<PagingModel>();

  showLoading: boolean = false;
  data:Array<any> = [];
  searchPerformed:boolean = false;
  get hasResults(){ return this.data?.length > 0 };

  displayColumns:DisplayColumn[]      = [];
  filters:any                         = {}; // new data structure to allow for binding to filters outside the table...

  // filters composed on the server side ----------------------------
  filterString:string                 = ""; // built from filters...
  filterModel:any                     = {}; // contains values
  showConfirmModal:boolean = false;
  fallsBackApi:boolean = false;
  confirmAction:string|null = null;
  lastClicked:any = null;
  lastSearch:any = undefined;

  public constructor(
    @Inject(DOCUMENT) private document: Document,
    protected searchService:SearchService,
    private eventsService:EventService,
    protected messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    protected serverClient: ServerClientService,
    protected model: MainModel, 
    private activeRoute: ActivatedRoute,
    protected permissions:UserPermissionsService,
    private confirmationService: ConfirmationService,
    private ngZone: NgZone ,
    private cd: ChangeDetectorRef
  ){

  }

  ngOnInit(): void {
    this.dataType = TableDataType.Report_Expenses;
    this.prepFilters();
  }
  
  
  getBlankFilter(obj:any):FilterModel{
    let filterModel:FilterModel = new FilterModel(obj);
    delete obj.options;
    return filterModel as FilterModel;
  }

  prepFilters():void {
    if(this.model?.selectedCampaign()?.campaignId){
      this.serverClient.getDataTableData(this.dataType || TableDataType.Report_Expenses, {}, this.model.selectedCampaign()?.campaignId || 0).subscribe(
        (data: any) => {
          data?.displayColumns?.sort(function(a:DisplayColumn, b:DisplayColumn) {
              return a.displayOrder - b.displayOrder;
          });
          this.displayColumns = data.displayColumns;
          // build model buckets for the range filters...
          this.displayColumns.forEach((i:DisplayColumn) => {
            const fltr = this.getBlankFilter(i);
            if(fltr.isFilterable === true){
              i.filterModel = fltr;
              this.filters[i.columnName] = i;
            }
          });
          this.cdr.detectChanges(); // this needs to be called due to async function calls...
          });
    } else {
      setTimeout( () => this.prepFilters(), 500);
    }
  }

  
  buildFilterData(): Array<MatchType> {
    const _filters:any = {};

    // set match type for the implicit campaign selected by the user for the current session...
    const campaignMatch:MatchType = new MatchType();
    campaignMatch.MatchMode = "equals";
    campaignMatch.Value = this.model.selectedCampaign()?.campaignId.toString();
    // the back end search current implementation takes this on the url whereas all other params are in the JSON...
    //_filters.CampaignID = campaignMatch;
    const _thisRef = this;
    Object.keys(this.filters).forEach(function(key,index) {
          const filter:MatchType = new MatchType();
          const ref = _thisRef.filters[key] as DisplayColumn;
          filter.Value = ref.filterModel.from.toString() === "" ? null : ref.filterModel.from ;
          filter.MatchMode = ref.filterModel.op;
          _filters[ref.columnName] = filter;
    });
    // all normalized into a MatchType array...
    return _filters;
  }
  

  resetFilters() {
    const _thisRef = this;
    Object.keys(this.filters).forEach(function(key,index) {
          const ref = _thisRef.filters[key] as DisplayColumn;
          const filterRef = ref.filterModel as FilterModel;
        if(filterRef.dataType === "multi"){
          filterRef.from = [];
          filterRef.op = "equals";
        } else {
          filterRef.from = "";
          filterRef.op = "contains";
        }
    });
    this.data = new Array<DisplayColumn>();
  }

  // search():void { 
  //   this.showLoading = true;
  //   const filterData:Array<any> = this.buildFilterData();
  //   this.searchService.search( this.dataType, JSON.stringify(
  //     filterData
  //    ) ).subscribe({
  //     next: (data: any[]) => {
  //       this.data = data;
  //       this.showLoading = false;
  //       this.cd.detectChanges();
  //     },
  //     error: (error:any) => {
  //       console.debug(error)
  //     }
  //   });
  // }
  
  search(filterData: MatchType[] = this.lastSearch): void {
    const _filters = JSON.stringify(filterData);
    const campaignId = this.model.selectedCampaign()?.campaignId;
    if (!campaignId) return;
  
    this.lastSearch = filterData;
    this.showLoading = this.searchPerformed = true;
    this.cd.detectChanges();
  
    this.fallsBackApi = false;
  
    const api$ = this.searchService.search(this.dataType, _filters, campaignId).pipe(
      shareReplay({ bufferSize: 1, refCount: true }),
      catchError(err => {
        console.error('Search error', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Fetching data failed.',
          life: 0
        });
        return EMPTY;
      })
    );
  
    const fallback$ = timer(5000).pipe(
      switchMap(() => {
        return new Promise((resolve) => {
          this.ngZone.run(() => {
            this.confirmationService.confirm({
              message: 'The report is taking longer than usual.',
              header: 'Campaign Report Export',
              acceptLabel: 'Email',
              rejectLabel: 'Cancel',
              rejectButtonStyleClass: 'p-button-outlined',
              accept: () => {
                this.fallsBackApi = true;
                this.showLoading = false;
  
                this.searchService.SendHangfireEmail(campaignId,filterData, 'DonorCycle')
                  .pipe(
                    catchError(err => {
                      console.error('Fallback error', err);
                      this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Fallback failed.',
                        life: 0
                      });
                      return EMPTY;
                    })
                  )
                  .subscribe();
  
                resolve('fallback'); 
              },
              reject: () => {
                resolve('continue'); 
              }
            });
          });
        });
      }),
      switchMap(result => {
        if (result === 'fallback') return EMPTY;
        return api$;
      })
    );
  
    race(api$, fallback$).subscribe(data => {
      if (this.fallsBackApi) return; 
      this.showLoading = false;
      this.data = data;
  
      if (data?.length > 0) {
          this.displayColumns = Object.keys(data[0]).map((key, index) => {
            return {
              id: index,
              columnName: key, 
              displayColumn: key, 
              displayColumnType: { type: 'string' }, 
              visible: true,
            } as unknown as DisplayColumn;
          });
        } else {
          this.displayColumns = [];
        }
  
      this.searchPerformed = true;
      this.cd.detectChanges();
    });
  }

  onSearch(): void {
    const filterData: any = this.buildFilterData();
    this.showLoading = true;
    this.data = [];
    this.lastSearch = filterData;
    this.search(filterData);
  }
  
  getDisplayValue(item:any, col:DisplayColumn){
      return  item[col.columnName];
  }

  
  pageChange(event: TablePageEvent) {
    this.updatePagingModel(event.first, event.rows);
  }
  
  updatePagingModel(start: number, maxResults: number = 10) {
    this.pagingModel.maxResults = maxResults;
    this.pagingModel.startRow = start;
    this.dataViewUpdate.emit(this.pagingModel);
  }

  exportToExcel(){
    let dateTime = new Date().toLocaleString();
    dateTime = dateTime.replaceAll(" ",":").replaceAll("/",".").replaceAll(",","");
    exportToExcel(this.data, `Expense Transactions Report`);
  }

}
